import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPositions } from 'api';
import { getCapexCriticalLevelAvailableColumns, getCriticalLevels } from './api';

export const path = '/capex/critical-level/list';

const PageCapexCriticalLevel: React.FC = (props) => {
  const CapexCriticalLevel = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getCapexCriticalLevelAvailableColumns,
      criticalLevels: getCriticalLevels,
      positions: getPositions,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <CapexCriticalLevel {...props} />;
};

export default PageCapexCriticalLevel;
